export enum CustomerFoodPreference {
    VEGETARIAN = "VEGETARIAN",
    NON_VEGETARIAN = "NON_VEGETARIAN",
    EGGETARIAN = "EGGETARIAN",
    JAIN = "JAIN",
}
